// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  margin: 0;
  background-color: white;
}

.red-label {
  color: red;
  font-weight: 700;
  margin: 10px;
}

.red-warning {
  color: red;
  margin: 10px;
  font-weight: 100;
  font-size: smaller;
}

.border-red {
  border: 2px solid red;
}

.high-probability {
  color: green;
}

.low-probability {
  color: red;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
